import Button from "components/button/Button";
import FormTextField from "components/form/FormTextField";
import { Spinner } from "components/spinner/Spinner";
import { ThemedLink } from "components/themedLink/ThemedLink";
import { Formik, Form } from "formik";
import { EmailVerificationProps, EmailVerificationCodePayload } from "pages/register/models";
import { postEmailVerificationCode } from "pages/register/RegisterApi";
import { handleTFAError } from "pages/register/RegistrationErrorHandling";
import React from "react";
import { useState } from "react";
import { dispatch } from "rxjs/internal/observable/pairs";
import { useTranslation } from "react-i18next";


type EmailNeedsVerificationProps = {
    accountDetails: any;
    formikProps: any;
}

export const EmailNeedsVerification: React.FC<EmailNeedsVerificationProps> = ({ accountDetails, formikProps }) => {
    const { t } = useTranslation('auth');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);


    const handleEmailCode = (resendCode: boolean, values: EmailVerificationCodePayload) => () => {

        setLoading(true);
        (async () => {
            const result = await postEmailVerificationCode(resendCode ? { ...values, bResendCode: true, emailVerificationCode: '' } : values);
            if (result.response) {
                setLoading(false)
            }
            if (result.errors && result.errors.length > 0) {
                setError(handleTFAError(result.errors[0]))
                setLoading(false)
            }
        })();
    };

    React.useEffect(() => {

        handleEmailCode(true, { username: accountDetails.emailAddress, password: accountDetails.password, bResendCode: true, emailVerificationCode: '' })()
    }, []);

    const handleResetError = () => {
        setError(null);
    }

    return (
        <div className="RegistrationForm WidthContent HeightContent">
            <Form onChange={handleResetError}>
                <div className="RegisterFormWidth">
                    <h1 className="notranslate" translate="no">{t('emailVerification')}</h1>
                    <p className="notranslate" translate="no">{t('enterCodeSentToEmail')}</p>
                    <FormTextField
                        field={'emailVerificationCode'}
                        label={t('verificationCode')}
                        required={true}
                        maxLength={6}
                        className="notranslate"
                    />
                    <ThemedLink onClick={handleEmailCode(true, formikProps.values)} className="RegisterLink notranslate">{t('resendCode')}</ThemedLink>
                    {error &&
                        <div className="ErrorMessage">{error}</div>
                    }
                    <Button priority="primary" variety="full" type="submit" disabled={loading} className="notranslate" translate="no">
                        {loading ?
                            <Spinner color={'#fff'} /> :
                            t('continue', { ns: 'common' })
                        }
                    </Button>
                </div>
            </Form>
        </div>
    );
};